import { Component, OnInit, Inject } from '@angular/core';
import { Guide, GuidePage } from '@model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-guide',
    templateUrl: './guide.component.html',
    standalone: false
})
export class GuideComponent implements OnInit {
  guide: Guide;
  pageNumber = 0;
  pages: GuidePage[] = [];

  constructor(public dialogRef: MatDialogRef<GuideComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    // Clone the object
    this.guide = { ...this.data, pages: this.data.pages.map(p => ({ ...p })) };

    // Sort pages
    this.guide.pages.sort((a, b) => {
      return this.compare(a.step, b.step, true);
    });
    this.pages = this.guide.pages;
  }

  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  onCancel() {
    this.dialogRef.close();
  }
}
